type SendButtonProps = {
  fileSending: boolean,
  handleFileSending: () => void
}

function SendButton(props: SendButtonProps) {
  return (
    <div className="SendButton">
      <button onClick={() => props.handleFileSending()} disabled={props.fileSending}>
        {props.fileSending ? "送信中..." : "承認して送信"}
      </button>
    </div>
  );
}

export default SendButton;
